import { BRUNI } from '@somnhold/content';
import { damageHero, ev } from '../combat.ts';
import { withinRange } from '../../math/fixed.ts';
import type { BattleState, Hero, Structure } from '../../types.ts';
import { by, standing, unOut } from './kit.ts';

/**
 * A tower Bruni's forge took (his ultimate, `turnedUntil`): instead of a nightmare it shoots the nearest standing
 * hero in its reach, each shot at least a share of the hero's health. With him gone, it is the bastion's again.
 * Returns whether it shot (its reload starts).
 */
export const turnedShot = (s: BattleState, st: Structure, x: number, y: number, range: number, dmg: number): boolean => {
  // Las vías 4: a tower left marked turns for the boss there, Bruni or (him fallen elsewhere) his biggest automaton.
  const e = unOut(s) ?? (s.rules?.rising && s.bossId ? s.enemies.find((x) => x.id === s.bossId && x.hp > 0) : undefined);
  if (!e) {
    st.turnedUntil = 0;
    return false;
  }
  let h: Hero | null = null;
  let bd = 0;
  for (const o of s.heroes) {
    if (!standing(o) || !withinRange(x, y, o.x, o.y, range)) continue;
    const d = (o.x - x) * (o.x - x) + (o.y - y) * (o.y - y);
    if (!h || d < bd) {
      h = o;
      bd = d;
    }
  }
  if (!h) return false;
  st.aim = h.id;
  damageHero(s, h, by(h, dmg, BRUNI.forge.shotMaxHpBp), e, undefined, true);
  ev(s, { t: 'beam', x, y, tx: h.x, ty: h.y, kind: 'bruniTurned' });
  return true;
};
